import { colorsPalettes } from "@similarweb/styles";
import { Box, Flex } from "@similarweb/ui-components/foundations";

import LoaderGradient, {
    LOADER_GREY_GRADIENT_ID,
} from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Loader/LoaderGradient";

const CompetitorsCardLoader = () => {
    return (
        <Box padding="8px 24px 0">
            {Array.from({ length: 5 }).map((_, index) => (
                <Flex
                    key={index}
                    alignItems="center"
                    justifyContent="space-between"
                    borderBottom={index === 4 ? "none" : `1px solid ${colorsPalettes.carbon["100"]}`}
                    height="62px"
                    padding="0 20px"
                    margin={index === 0 ? "6px 0 0" : "0"}
                >
                    <Box
                        width="20%"
                        key={"1"}
                    >
                        <LoaderGradient
                            height={6}
                            id={LOADER_GREY_GRADIENT_ID}
                        />
                    </Box>
                    <Box
                        width="20%"
                        key={"2"}
                    >
                        <LoaderGradient
                            height={6}
                            id={LOADER_GREY_GRADIENT_ID}
                        />
                    </Box>
                    <Box
                        width="47%"
                        key={"3"}
                    >
                        <LoaderGradient
                            height={6}
                            id={LOADER_GREY_GRADIENT_ID}
                        />
                    </Box>
                </Flex>
            ))}
        </Box>
    );
};

export default CompetitorsCardLoader;
